export default "__VITE_ASSET__e85yXZAR__"